import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class CloudwaysCancelled extends React.Component {
	render() {
		const { migrate, history } = this.props
		return <div className="cws d-flex">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="migration-box text-center">
							<div>
								<img className="" src="/assets/cloudways/cws-exclamation.svg" alt=""/>
								<h1 className="font-36 color-0E134F proxima-regular my-2">Migration Cancelled</h1>
								<p className="v-center py-1 site-urls" style={{justifyContent: 'center'}}>
									<a href={migrate.get('source_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
										{migrate.get('source_site')}
									</a>
									<img className="arrow-icon" src="/assets/cloudways/cws-blue-arrow.svg" alt=""/>
									<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
										{migrate.get('destination_site')}
									</a>
								</p>
							</div>
							<div className="cw-border-1 mt-2 mb-4"/>
							<div className="mt-5 mb-5">
								<h6 className="font-16  color-000 proxima-regular">
									Don’t have the time?&nbsp;
									<a href="https://support.cloudways.com/how-to-request-a-managed-application-migration-to-cloudways/"
										target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-16 td-none">
										Let us migrate your site for free!
									</a>
								</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}         
}           

CloudwaysCancelled.propTypes = {
	migrate: ImmutablePropTypes.map,
	history: PropTypes.object
}

export default CloudwaysCancelled
